import * as Yup from 'yup';
import moment from 'moment';

export const shipmentOverviewSchema = () => {
    const requiredFieldMessage = 'Required';
    const dateAfterMessage = (date: string) => `Date needs to be after ${date}`;
    return Yup.object().shape({
        goodsValueCurrency: Yup.string()
            .nullable()
            .when(['goodsValue'], (goodsValue: string, schema: any) => {
                return schema.test({
                    test: (goodsValueCurrency: string) => (!!goodsValue ? !!goodsValueCurrency : true),
                    message: requiredFieldMessage
                });
            }),
        transportationPriceCurrency: Yup.string()
            .nullable()
            .when(['transportationPrice'], (transportationPrice: string, schema: any) => {
                return schema.test({
                    test: (transportationPriceCurrency: string) => (!!transportationPrice ? !!transportationPriceCurrency : true),
                    message: requiredFieldMessage
                });
            }),
        quantity: Yup.string()
            .nullable()
            .when(['volume', 'weight'], {
                is: (volume: string, weight: string) => !!Number(volume) || !!Number(weight),
                then: Yup.string().required(requiredFieldMessage)
            })
            .test('min-quantity', 'Quantity must be greater than 0', function(value) {
                if (value !== null && value !== undefined && value !== '' && Number(value) <= 0) {
                    return this.createError({ message: 'Quantity must be greater than 0' });
                }
                return true;
            }),
        eta: Yup.date()
            .when('etd', (st: string, schema: any) => {
                if (st) {
                    return schema.min(new Date(st), dateAfterMessage(moment(st).format('DD/MM/YYYY')));
                }

                return;
            })
            .nullable(),
        master: Yup.string()
            .nullable()
            .test('no-special-chars', 'Master can only contain letters, numbers, and hyphens', (val) => !val || /^[a-zA-Z0-9\-]*$/.test(val)),
        house: Yup.string()
            .nullable()
            .test('no-special-chars', 'House can only contain letters, numbers, and hyphens', (val) => !val || /^[a-zA-Z0-9\-]*$/.test(val)),
        declarationNumber: Yup.string().nullable().max(255, 'Max 255 characters'),
        storageSiteCode: Yup.string().nullable().max(50, 'Max 50 characters'),
        storageSiteName: Yup.string().nullable().max(255, 'Max 255 characters'),
        handlingAgent: Yup.string().nullable(),
        coLoader: Yup.string().nullable()
    });
};
